import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Button, Modal, Card } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';

function Plans({ setPlanBuyed }) {
    const [show, setShow] = useState(false);
    const [step, setStep] = useState(1);
    const [selectedType, setSelectedType] = useState(null);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [selectedDuration, setSelectedDuration] = useState(null);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const { authenticated } = useAuth();
    const navigate = useNavigate();

    const handleNextStep = () => {
        if (step === 1 && !selectedType) return;
        if (step === 2 && (!selectedPlan || !selectedDuration)) return;

        if (step === 2) {
            setShow(false);
            setShowSuccessModal(true);
            setPlanBuyed(true);
        } else {
            setStep(step + 1);
        }
    };

    useEffect(() => {
        if (showSuccessModal) {
            const timer = setTimeout(() => {
                setShowSuccessModal(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [showSuccessModal]);

    const videoTypes = [
        'YouTube Insta TikTok Videos ',
        'Anime music Video',
        'Sport Video',
        'Travel Video',
        'Party Event Video',
        'Music Video',
        'Food Video',
        'Podcast Audio Only',
        'Podcast Audio and Video',
        'Weeding Video',
        'Weeding Photo'
    ];

    const plans = [
        {
            title: 'Basic Cut and Audio',
            options: [
                { label: '1 minute', price: '€24.99' },
                { label: '3 minutes', price: '€39.99' },
                { label: '5 minutes', price: '€54.99' }
            ]
        },
        {
            title: 'Cut Audio Color and Audio Mixing',
            options: [
                { label: '1 minute', price: '€24.99' },
                { label: '3 minutes', price: '€39.99' },
                { label: '5 minutes', price: '€54.99' }
            ]
        },
        {
            title: 'Premium Motion Graphic and Subtitle',
            options: [
                { label: '1 minute', price: '€24.99' },
                { label: '3 minutes', price: '€39.99' },
                { label: '5 minutes', price: '€54.99' }
            ]
        }
    ];


    return (
        <>
            <section id="plans-section" className="plans">
                <Container>
                    <h2 className="mb-4 text-center">Choose Our Package</h2>
                    <p className="text-muted text-center">
                        {!authenticated ? (
                            <>
                            Select the perfect video editing plan for your needs. Each package is designed to deliver quality and speed. <small><strong>Please login </strong> before uploading your videos.</small>
                            </>
                        ) : (
                            <>
                            Select the perfect video editing plan for your needs. Each package is designed to deliver quality and speed.
                            </>
                        )}        
                    </p>
                    {authenticated ? (
                        <Button variant="primary" size="lg" onClick={handleShow}>
                            View & Buy a Plan
                        </Button>
                    ) : (
                        <Button
                            variant="primary"
                            size="lg"
                            onClick={() => {
                                authenticated ? handleShow() : navigate('/signin');
                            }}
                        >
                            View & Buy a Plan
                        </Button>
                    )}
                </Container>
            </section>

            <Modal show={show} centered onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {step === 1 && (
                            <>Choose Video Type</>
                        )}
                        {step === 2 && (
                            <>Selected Video Type : {selectedType}</>
                        )}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {step === 1 && (
                        <div className='select-video-type'>
                            <p>Choose your preferred category to explore the available packages.</p>
                            <ul className="list-group">
                                {videoTypes.map((type, idx) => {
                                    const isSelected = selectedType === type;
                                    return (
                                        <li
                                            key={idx}
                                            className={`list-group-item d-flex justify-content-between align-items-center ${isSelected ? 'selected-item' : ''}`}
                                        >
                                            {type}
                                            <Button
                                                variant={isSelected ? "success" : "outline-primary"}
                                                size="sm"
                                                onClick={() => setSelectedType(type)}
                                            >
                                                {isSelected ? "Selected" : "Select"}
                                            </Button>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    )}

                    {step === 2 && (
                        <div className="select-video-plan">
                            {plans.map((plan, idx) => (
                                <Card className={`${selectedPlan === plan.title ? 'border-primary' : ''}`}>
                                    <Card.Body>
                                        <Card.Title>{plan.title}</Card.Title>
                                        {plan.options.map((opt, i) => {
                                            const isSelected =
                                                selectedPlan === plan.title &&
                                                selectedDuration === opt.label;
                                            return (
                                                <Button
                                                    key={i}
                                                    variant={isSelected ? 'success' : 'outline-secondary'}
                                                    className="mb-2 w-100"
                                                    onClick={() => {
                                                        setSelectedPlan(plan.title);
                                                        setSelectedDuration(opt.label);
                                                    }}
                                                >
                                                    <label>{opt.label}</label> <span>{opt.price}</span>
                                                </Button>
                                            );
                                        })}
                                    </Card.Body>
                                </Card>
                            ))}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    {step !== 1 && (
                        <Button variant="info" onClick={() => setStep(step - 1)}>
                            Back
                        </Button>
                    )}
                    <Button
                        variant="primary"
                        onClick={handleNextStep}
                        disabled={step === 1 && !selectedType}
                    >
                        {step === 2 ? 'Confirm' : 'Continue'}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={showSuccessModal}
                onHide={() => setShowSuccessModal(false)}
                centered
                size="sm"
                className='upload-successful-modal'
            >
                <Modal.Header closeButton>
                    <Modal.Title>🎉 Congratulations!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h5>Purchase Confirmed!</h5>
                    <p><strong>Your package has been successfully purchased.</strong></p>
                    <p>We’ve sent a confirmation to your email. You can now upload your video files to start your project.</p>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default Plans;
